import {COLORS, COMPARE_TO} from './constants';

export const contentToSelectOption = (value: any) => {
  return {
    label: value.name,
    value: value.uid,
  }
}

export const createDefaultContent = () => {
  return {
    source: '',
    source_uid: '',
    column: '',
    format: '#,##0.###',
    is_percentage: false,
    comparison: {
      show: false,
      format: '#,##0.###',
      is_percentage: false,
    },
    sparkline: {
      color: COLORS[0].name,
      show: true,
    },
    export_options: {
      embed: true,
    }
  }
};

export const getColumnsFromSource = (source: any) => {
  return source?.value?.columns?.map((column: any) => ({
    label: column.name,
    value: column.name,
  })) || [];
}

export const sourceDataToSparklineData = (source: any, yColumn: string, xColumn?: string | undefined) => {
  return source?.value?.data?.map((row: any, index: number) => ({
    x: row[xColumn || yColumn], // used to show label on x-axis (1st, last)
    y: row[yColumn],
    index: index,
  })) || [];
};

const NO_DATA = 'No Data'; // KPI number when there is no data

export const getKPINumber = (source: any, column: string, isPercentage?: boolean) => {
  const lastRow = source?.value?.data?.[source?.value?.data?.length - 1];

  const value = lastRow?.[column] || null;

  if (value && isPercentage) {
    return value * 100;
  }

  return value || NO_DATA;
};

export const compareKPINumber = (
  source: any,
  column: string,
  compareToType: string,
  compareToColumn?: string,
  compareToColumnIsPercentage?: boolean,
) => {
  const data = source?.value?.data || [];
  const kpiNumber = getKPINumber(source, column); // last number
  let compareToValue = null;

  if (kpiNumber === NO_DATA) {
    return NaN;
  }

  if (compareToType === COMPARE_TO.PREVIOUS_ROW) {
    if (data.length < 2) {
      return NaN;
    }
    compareToValue = data[data.length - 2][column];
  } else if (compareToType === COMPARE_TO.ANOTHER_COLUMN) {
    compareToValue = getKPINumber(source, compareToColumn || '');

    if (compareToValue === NO_DATA) {
      return NaN;
    }
  }

  if (compareToValue !== null) {
    if (compareToColumnIsPercentage) {
      if (compareToValue === 0) {
        return kpiNumber; // avoid division by zero
      }
      return ((kpiNumber - compareToValue) / compareToValue) * 100;
    }
    return kpiNumber - compareToValue;
  }

  return NaN;
}

export const getColorByName = (currentColorName: string | undefined) => {
  let index = 0;
  if (currentColorName) {
    index = COLORS.findIndex((color) => color.name === currentColorName);
  }

  return {
    color: {
      ...COLORS[index],
    },
    index,
  };
}

export const getColorByIndex = (index: number) => {
  if (index >= COLORS.length) {
    index = 0;
  }
  return {
    color: {
      ...COLORS[index],
    },
    index,
  }
};
